import {Component, OnInit} from "@angular/core";
import {ModalController, NavController} from "@ionic/angular";
import {SessionService} from "../services/session.service";
import {ChangePasswordComponent} from "../components/change-password/change-password.component";
import {DataStore} from "@aws-amplify/datastore";
import {User} from "src/models";

@Component({
    selector: "app-settings",
    templateUrl: "./settings.page.html",
    styleUrls: ["./settings.page.scss"],
})
export class SettingsPage implements OnInit {
    public user: User;
    public notification: Boolean

    constructor(
        private navController: NavController,
        public sessionService: SessionService,
        public modalController: ModalController,
    ) {
    }

    async ngOnInit() {
        this.user = await DataStore.query(User, this.sessionService.user?.id);
        if (this.user) {
            this.notification = true;
        } else
            this.notification = false;
    }

    changeTheme(event) {
        localStorage.setItem("theme", event.target.value);
    }

    back() {
        this.navController.back();
    }

    async openModal() {
        const modal = await this.modalController.create({

            component: ChangePasswordComponent,
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            // this.refreshProfile();
        });
    }

    changeNotify() {

    }

    async notificationChanged(event: any) {
        if (event.detail.checked) {
            this.user = await DataStore.save(User.copyOf(this.user, u => {
                u.notification = true;
            }));
        } else {
            this.user = await DataStore.save(User.copyOf(this.user, u => {
                u.notification = false;
            }));
        }
        
    }

    openPage(s: string) {
        
    }
    deleteAccount(){
        if (confirm("Sicuro di voler cancellare il tuo account?")){
            alert("La tua richiesta è stata presa in considerazione, presto un nostro agente provvederà a cancellare l'account ! ")
        }
    }
}
